export default __webpack_public_path__ + "static/media/location.814c96d4.svg";